import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const BRIDGING_VISA_VEVO_SOURCES = [
  {
    sourceId: "bridging-vevo-source-overview",
    topicId: "bridging-visa-vevo",
    title: "Check visa details and conditions",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/already-have-a-visa/check-visa-details-and-conditions/overview",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs 공식 VEVO 안내에서 현재 in-effect 비자, 만료일·체류기간·조건을 확인하고 아직 발효되지 않은 bridging visa는 표시되지 않을 수 있음을 확인",
    reviewStatus: "live_verified",
    claimScope: "VEVO가 표시하는 현재 비자·조건과 표시 범위",
    followUp: "행동 직전 최신 VEVO 결과와 grant notice를 함께 저장",
  },
  {
    sourceId: "bridging-vevo-source-bva",
    topicId: "bridging-visa-vevo",
    title: "Bridging visa A (subclass 010)",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/bridging-visa-a-010",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs BVA 공식 본문에서 발효·근로조건, 출국 시 BVA로 재입국할 수 없고 출국 전 BVB가 필요할 수 있음을 확인",
    reviewStatus: "live_verified",
    claimScope: "BVA의 체류·근로·여행 일반 경계",
    followUp: "개인 grant notice와 VEVO 조건, review·judicial review 상태 재확인",
  },
  {
    sourceId: "bridging-vevo-source-bvb",
    topicId: "bridging-visa-vevo",
    title: "Bridging visa B (subclass 020)",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/bridging-visa-b-020",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs BVB 공식 본문에서 substantive visa 처리 중 지정된 travel period에 출국·재입국할 수 있음을 확인",
    reviewStatus: "live_verified",
    claimScope: "BVB travel period와 재입국의 일반 경계",
    followUp: "출국 전 BVB grant, travel period, passport와 재입국 조건 직접 확인",
  },
  {
    sourceId: "bridging-vevo-source-bvc",
    topicId: "bridging-visa-vevo",
    title: "Bridging visa C (subclass 030)",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/bridging-visa-c-030",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs BVC 공식 본문에서 체류·근로조건과 출국 시 BVC가 종료되고 BVC 보유자는 BVB를 받을 수 없다는 여행 경계를 확인",
    reviewStatus: "live_verified",
    claimScope: "BVC의 발효·근로·여행 일반 경계",
    followUp: "출국 전 현재 visa와 재입국 가능한 별도 visa 존재 여부 전문 확인",
  },
  {
    sourceId: "bridging-vevo-source-bve",
    topicId: "bridging-visa-vevo",
    title: "Bridging visa E (subclass 050)",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/Visa-subsite/Pages/other-visas/050-bridging-visa-e.aspx",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs BVE 공식 본문에서 lawful stay 목적, grant letter별 근로조건, 출국 시 즉시 종료와 status resolution 안내를 확인",
    reviewStatus: "live_verified",
    claimScope: "BVE의 체류·근로·종료·여행 일반 경계",
    followUp: "BVE expiry event, work condition와 unresolved immigration matter를 즉시 재확인",
  },
  {
    sourceId: "bridging-vevo-source-application",
    topicId: "bridging-visa-vevo",
    title: "Submit a Bridging visa A, B or C application online",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/help-support/departmental-forms/online-forms/bridging-a-b-c-visa-application-online",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs 공식 online form에서 ImmiAccount·webform 경로, replacement·condition variation·BVB travel request와 supporting documents 요구를 확인",
    reviewStatus: "live_verified",
    claimScope: "BVA·BVB·BVC 신청·교체·조건변경의 공식 제출 경로",
    followUp: "현재 application method, 정확한 form과 charge를 제출 직전 확인",
  },
  {
    sourceId: "bridging-vevo-source-enquiry",
    topicId: "bridging-visa-vevo",
    title: "VEVO enquiry form",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/help-support/departmental-forms/online-forms/vevo-enquiry-form",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs 공식 VEVO enquiry form에서 visa holder error 지원 범위와 current in-effect visa만 조회 가능하다는 제한을 확인",
    reviewStatus: "live_verified",
    claimScope: "VEVO 오류·접근 문제의 공식 문의 경로",
    followUp: "passport update와 reference number를 먼저 확인한 뒤 오류 화면을 첨부",
  },
  {
    sourceId: "bridging-vevo-source-status-resolution",
    topicId: "bridging-visa-vevo",
    title: "Immigration Status Resolution Service",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/what-we-do/status-resolution-service/overview",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Home Affairs 공식 Status Resolution Service에서 valid visa가 없거나 BVE 상태인 사람의 status resolution 지원과 BVE 신청 안내를 확인",
    reviewStatus: "live_verified",
    claimScope: "unlawful status·BVE 상태의 공식 status resolution 지원",
    followUp: "현재 visa가 없거나 BVE이면 즉시 eligibility와 appointment 경로 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of BRIDGING_VISA_VEVO_SOURCES) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
